export default __webpack_public_path__ + "static/media/12.28ef8933.webp";